import { FiFacebook, FiInstagram, FiLinkedin, FiMail, FiMapPin, FiPhone, FiTwitter } from 'react-icons/fi'
import './Footer.css'
import { useTranslation } from 'react-i18next';
const Footer = () => {
  const { t } = useTranslation();
   return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-about">
            <div className="footer-logo">
              <span className="logo-text">
                {t('footer.logoInvoice')}
                <span className="logo-accent">{t('footer.logoTrack')}</span>
              </span>
            </div>
            <p className="footer-description">
              {t('footer.description')}
            </p>
            <div className="footer-social">
              <a href="#" className="social-icon"><FiTwitter /></a>
              <a href="#" className="social-icon"><FiFacebook /></a>
              <a href="#" className="social-icon"><FiInstagram /></a>
              <a href="#" className="social-icon"><FiLinkedin /></a>
            </div>
          </div>

          <div className="footer-links">
            <h4>{t('footer.quickLinks.title')}</h4>
            <ul>
              <li><a href="/">{t('footer.quickLinks.home')}</a></li>
              <li><a href="/features">{t('footer.quickLinks.features')}</a></li>
              <li><a href="/pricing">{t('footer.quickLinks.pricing')}</a></li>
              <li><a href="/about">{t('footer.quickLinks.aboutUs')}</a></li>
              <li><a href="/contact">{t('footer.quickLinks.contact')}</a></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>{t('footer.resources.title')}</h4>
            <ul>
              <li><a href="/blog">{t('footer.resources.blog')}</a></li>
              <li><a href="/support">{t('footer.resources.supportCenter')}</a></li>
              <li><a href="/guides">{t('footer.resources.guides')}</a></li>
              <li><a href="/api">{t('footer.resources.apiDocs')}</a></li>
              <li><a href="/partners">{t('footer.resources.partnerProgram')}</a></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>{t('footer.contact.title')}</h4>
            <div className="contact-info">
              
           
              <div className="contact-item">
                <FiMail />
                <span>{t('footer.contact.email')}</span>
              </div>
                 <div className="contact-item">
                <FiPhone />
                <span>
                    <i className="fab fa-whatsapp w-5 h-5 text-green-500 mr-3 mt-0.5"></i>
              <a 
                href="https://wa.me/212762645725" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                WhatsApp
              </a>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            © {new Date().getFullYear()} InvoiceTrack. {t('footer.rights')}
             <p className="text-gray-600 dark:text-gray-400 text-sm mt-2 md:mt-0">
              Built with ❤️ by <a href='https://adnane-abdellaoui.netlify.app/'>Adnane.dev</a> 
            </p>
          </div>
          <div className="footer-legal">
            <a href="/terms">{t('footer.terms')}</a>
            <a href="/privacy">{t('footer.privacy')}</a>
            <a href="/security">{t('footer.security')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};


export default Footer